const types = require('constants/actionTypes');

const resultSelected = ({ result }) => ({
    type: types.GLOSSARY_RESULT_SELECTED,
    payload: { result },
});

module.exports = resultSelected;
